<template>
  <div class="home">
    <!-- 轮播图 -->
    <van-swipe :autoplay="3000" indicator-color="#fff">
      <van-swipe-item @click="$router.push('about')">
        <img class="cover" src="../assets/pc/swiper1.jpg" v-if="isPc">
        <img class="cover" src="../assets/wap/swiper1.jpg" v-else>
      </van-swipe-item>
      <van-swipe-item @click="$router.push('about')">
        <img class="cover" src="../assets/pc/swiper2.jpg" v-if="isPc">
        <img class="cover" src="../assets/wap/swiper2.jpg" v-else>
      </van-swipe-item>
    </van-swipe>

    <!-- 关于我们 -->
    <div @click="$router.push('about')">
      <img class="cover" src="../assets/pc/about.gif" v-if="isPc">
      <template v-else>
        <img class="cover" src="../assets/wap/about1.jpg">
        <img class="cover" src="../assets/wap/about2.jpg">
      </template>
    </div>


    <!-- 我们的服务 -->
    <img class="cover" src="../assets/pc/service.gif" v-if="isPc">
    <img class="cover" src="../assets/wap/service.jpg" v-else>

    <!-- 合作客户 -->
    <img class="cover" src="../assets/pc/customer.gif" v-if="isPc">
    <img class="cover" src="../assets/wap/customer.jpg" v-else>

  </div>
</template>

<script>

export default {
  name: 'Home',
  computed: {
    isPc() {
      return this.$store.getters.isPc
    }
  }
}
</script>
